<template>
  <div class="App-news bg-white">
    <div class="inner text-center">
      <h1 class="h1 title">{{ $t('news.title') }}</h1>
      <div class="content text-left">
        <div class="list news-wrapper">
          <ul class="list-group" v-show="!news.loading">
            <router-link class="list-group_item" tag="li" v-for="post in news.list" :key="post.id" :to="{name: 'news.detail', params: {id: post.id}}">
              <div class="text-black"><span class="d-inline-block">{{ post.date | moment('YYYY/MM/DD') }}</span>
                <p class="d-md-inline-block">{{ post.title.rendered | truncate(40) }}</p>
              </div>
            </router-link>
          </ul>
          <div class="text-center mt-2" v-show="news.loading">
            <vue-loading type="spin" color="#DB1016" :size="{ width: '50px', height: '50px' }"></vue-loading>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import moment from 'moment-timezone'
  import { VueLoading } from 'vue-loading-template'
  import { META_NEWS } from '../../mixins/metadata.js'

  export default {
    mixins: [META_NEWS],
    name: 'NewsIndexPage',
    components: {
      VueLoading,
    },
    computed: {
      ...mapState('news', ['news']),
    },
    methods: {
      ...mapActions('news', ['getNews']),
      isSameCurrentDay(date) {
        return moment(date).isSame(moment(), 'day')
      }
    },
    filters: {
      truncate(text, stop, clamp) {
        return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '')
      }
    },
    mounted() {
      this.getNews(100)
    }
  }
</script>
